export const AVATAR_TONE_COUNT = 8

const TONE_CLASS = [
  "bg-[var(--ui-avatar-1-bg)] text-[var(--ui-avatar-1-fg)]",
  "bg-[var(--ui-avatar-2-bg)] text-[var(--ui-avatar-2-fg)]",
  "bg-[var(--ui-avatar-3-bg)] text-[var(--ui-avatar-3-fg)]",
  "bg-[var(--ui-avatar-4-bg)] text-[var(--ui-avatar-4-fg)]",
  "bg-[var(--ui-avatar-5-bg)] text-[var(--ui-avatar-5-fg)]",
  "bg-[var(--ui-avatar-6-bg)] text-[var(--ui-avatar-6-fg)]",
  "bg-[var(--ui-avatar-7-bg)] text-[var(--ui-avatar-7-fg)]",
  "bg-[var(--ui-avatar-8-bg)] text-[var(--ui-avatar-8-fg)]",
] as const

const FNV_OFFSET = 0x811c9dc5
const FNV_PRIME = 0x01000193

export function avatarToneIndex(seed: string): number {
  const normalized = seed.replace(/\s+/g, "").toLowerCase()
  let hash = FNV_OFFSET
  for (let i = 0; i < normalized.length; i += 1) {
    hash ^= normalized.charCodeAt(i)
    hash = Math.imul(hash, FNV_PRIME) >>> 0
  }
  return (hash % AVATAR_TONE_COUNT) + 1
}

export function avatarToneClassName(seed: string): string {
  return TONE_CLASS[avatarToneIndex(seed) - 1]
}

export function companyAvatarSeed(id: number): string {
  return `company:${id}`
}

export function projectAvatarSeed(id: number): string {
  return `project:${id}`
}

export function companyInitials(name: string): string {
  const words = name
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
  if (words.length === 0) return "•"
  if (words.length === 1) return Array.from(words[0]).slice(0, 2).join("").toUpperCase()
  return `${Array.from(words[0])[0]}${Array.from(words[1])[0]}`.toUpperCase()
}

export function projectInitial(name: string): string {
  const match = name.match(/[\p{L}\p{N}]/u)
  return match ? match[0].toUpperCase() : "•"
}
